import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPresetQuoteTemplateApi,
  deletePresetQuoteTemplateApi,
  getPresetQuoteDetailApi,
  getPresetQuoteListApi,
  updatePresetQuoteTemplateApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import { PresetQuoteArgs, PresetQuotePayload } from "types/preset.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

type PartialExceptId<T extends { id: any }> = Partial<T> & { id: T["id"] };

export const getPresetQuoteList = createAsyncThunk<
  ApiResponse<PaginatedPayload<PresetQuotePayload>>,
  PresetQuoteArgs
>("presetQuote/list", async (params, { rejectWithValue }) => {
  try {
    const response = await getPresetQuoteListApi(params);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getPresetQuoteDetail = createAsyncThunk<
  ApiResponse<PresetQuotePayload>,
  { templateId: number }
>("presetQuote/detail", async ({ templateId }, { rejectWithValue }) => {
  try {
    const response = await getPresetQuoteDetailApi({ templateId: templateId });
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createPresetQuoteTemplate = createAsyncThunk<
  ApiResponse<PresetQuotePayload>,
  { data: Partial<PresetQuotePayload> }
>("presetQuote/create", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await createPresetQuoteTemplateApi(data);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updatePresetQuoteTemplate = createAsyncThunk<
  ApiResponse<PresetQuotePayload>,
  { data: PartialExceptId<PresetQuotePayload> }
>("presetQuote/update", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await updatePresetQuoteTemplateApi(data);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deletePresetQuoteTemplate = createAsyncThunk(
  "presetQuote/delete",
  async ({ templateId }: { templateId: number }, { rejectWithValue }) => {
    try {
      const res = await deletePresetQuoteTemplateApi({
        templateId: templateId,
      });
      SuccessToast(res.message);
      return { templateId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
